"use strict";

var _interopRequireDefault = require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

require("core-js/modules/es7.object.get-own-property-descriptors");

require("core-js/modules/es6.object.keys");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.set");

require("core-js/modules/es6.function.name");

var _defineProperty2 = _interopRequireDefault(require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/defineProperty.js"));

require("core-js/modules/es6.array.find");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es7.object.values");

require("core-js/modules/web.dom.iterable");

require("regenerator-runtime/runtime");

var _asyncToGenerator2 = _interopRequireDefault(require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));

require("core-js/modules/es6.regexp.replace");

require("core-js/modules/es6.regexp.split");

require("core-js/modules/es6.number.constructor");

require("core-js/modules/es7.array.includes");

require("core-js/modules/es6.string.includes");

var _order = require("@/api/cms/order");

var _contract = require("@/api/cms/contract");

var _designSchemeApi = require("@/api/designSchemeApi");

var _cmsCustBom = require("@/api/cmsCustBom");

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }

function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

var _default = {
  name: 'OrderCreate',
  data: function data() {
    return {
      screenHeight: document.documentElement.clientHeight || document.body.clientHeight,
      coolHomePlanList: [],
      reviewList: [],
      auditList: [],
      // 提审单信息
      specialApplyOptions: [],
      // 特殊申请选项列表
      originalOrderOptions: [],
      // 原单号选项列表
      page: 0,
      size: 10,
      contractNo: '',
      coolHomeDialogVisible: false,
      coolHomeFrameUrl: '',
      selectedAuditIds: [],
      // 选中的提审单ID数组
      selectedSchemeIds: [],
      // 选中的方案ID数组
      auditSelections: {},
      // 每个方案下的提审单选中状态 { schemeRowId: [auditRowId, ...] }
      expandedRows: [],
      // 展开行的ID数组
      isAllExpanded: false,
      // 是否全部展开
      refreshLoading: false,
      syncLoading: false,
      orderLoading: false,
      // 选择订单弹窗
      showSelectOrderDialog: false,
      selectOrderLoading: false,
      originalAuditList: [],
      currentSelectOrderRow: null,
      // 大家居订单-成品物料弹窗
      showDajiajuOrderDialog: false,
      dajiajuMaterialLoading: false,
      dajiajuSubmitting: false,
      dajiajuMaterialList: [],
      dajiajuMaterialTotal: 0,
      dajiajuMaterialPage: 1,
      dajiajuMaterialPageSize: 10,
      dajiajuMaterialSearch: {
        code: '',
        name: ''
      },
      tempSelectedDajiajuMaterials: []
    };
  },
  mounted: function mounted() {
    window.addEventListener('resize', this.handleResize); // 从路由参数中获取合同信息

    var contractNo = this.$route.query.contractNo;

    if (contractNo) {
      this.contractNo = contractNo;
    } // 有合同ID才查询设计方案


    if (this.$route.query.contractId) {
      this.getDesignSchemes();
    } // 组件挂载时获取酷家乐地址


    this.getKuJiaLeUrl(); // 组件挂载时获取特殊申请列表

    this.getSpecialApplyList(); // 组件挂载时获取原单号列表

    this.getOriginalOrderList();
  },
  watch: {
    $route: {
      handler: function handler(newRoute) {
        var contractNo = newRoute.query.contractNo;

        if (contractNo) {
          this.contractNo = contractNo;
        }

        if (newRoute.query.contractId) {
          this.getDesignSchemes();
        } else {
          this.coolHomePlanList = [];
        }

        this.getKuJiaLeUrl();
        this.getSpecialApplyList();
        this.getOriginalOrderList();
        this.auditList = [];
        this.selectedAuditIds = [];
        this.auditSelections = {};
      },
      deep: true
    }
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  computed: {
    isAllChecked: function isAllChecked() {
      var editableSchemes = this.coolHomePlanList.filter(function (item) {
        return item.designSchemeAudits && item.designSchemeAudits.some(function (a) {
          return a.productionStatus === '未提交' || a.productionStatus === '回退';
        });
      });
      return editableSchemes.length > 0 && editableSchemes.every(function (item) {
        return item._checked;
      });
    },
    isIndeterminate: function isIndeterminate() {
      var editableSchemes = this.coolHomePlanList.filter(function (item) {
        return item.designSchemeAudits && item.designSchemeAudits.some(function (a) {
          return a.productionStatus === '未提交' || a.productionStatus === '回退';
        });
      });
      return editableSchemes.some(function (item) {
        return item._checked;
      }) && !editableSchemes.every(function (item) {
        return item._checked;
      });
    },
    // 选中项中是否包含成品单（成品单不允许批量下单）
    hasSelectedChengpinAudit: function hasSelectedChengpinAudit() {
      var _this = this;

      var selectedIds = this.selectedAuditIds;
      if (!selectedIds || selectedIds.length === 0) return false;
      return this.coolHomePlanList.some(function (scheme) {
        return (scheme.designSchemeAudits || []).some(function (audit) {
          return selectedIds.includes(audit.rowId) && _this.isChengpinAudit(audit);
        });
      });
    },
    canBatchSetTryInstall: function canBatchSetTryInstall() {
      var selectedAudits = this.getSelectedAuditRows();
      return selectedAudits.length > 0 && selectedAudits.length === this.selectedAuditIds.length && selectedAudits.every(function (audit) {
        return audit.productionStatus === '未提交' && audit.isTryInstall !== null && audit.isTryInstall !== undefined && Number(audit.isTryInstall) === 0;
      });
    },
    canBatchCancelTryInstall: function canBatchCancelTryInstall() {
      var selectedAudits = this.getSelectedAuditRows();
      return selectedAudits.length > 0 && selectedAudits.length === this.selectedAuditIds.length && selectedAudits.every(function (audit) {
        return audit.productionStatus === '未提交' && Number(audit.isTryInstall) === 1;
      });
    }
  },
  methods: {
    getSelectedAuditRows: function getSelectedAuditRows() {
      var _this2 = this;

      return this.coolHomePlanList.reduce(function (selectedAudits, scheme) {
        return selectedAudits.concat((scheme.designSchemeAudits || []).filter(function (audit) {
          return _this2.selectedAuditIds.includes(audit.rowId);
        }));
      }, []);
    },
    handleResize: function handleResize() {
      this.screenHeight = document.documentElement.clientHeight || document.body.clientHeight;
    },
    parseSpecialApply: function parseSpecialApply(value) {
      if (!value) return [];

      try {
        return JSON.parse(value);
      } catch (e) {
        if (typeof value === 'string' && value.includes(',')) {
          return value.split(',').map(function (item) {
            return item.trim().replace(/^['"]|['"]$/g, '');
          });
        }

        return [];
      }
    },
    goBack: function goBack() {
      window.history.back();
    },
    refreshData: function refreshData() {
      var _this3 = this;

      this.refreshLoading = true;
      this.getDesignSchemes().finally(function () {
        _this3.refreshLoading = false;

        _this3.$message.success('刷新成功');
      });
    },
    toggleAllExpand: function toggleAllExpand() {
      if (this.isAllExpanded) {
        this.expandedRows = [];
      } else {
        this.expandedRows = this.coolHomePlanList.map(function (item) {
          return item.rowId;
        });
      }

      this.isAllExpanded = !this.isAllExpanded;
    },
    // 获取酷家乐地址
    getKuJiaLeUrl: function () {
      var _getKuJiaLeUrl = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var contractId, response, kuJiaLeFrameUrl, coolHomeDesignUrlTemplate, coolHomeDesignUrl;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                // 获取合同ID
                contractId = this.$route.query.contractId;

                if (contractId) {
                  _context.next = 3;
                  break;
                }

                return _context.abrupt("return");

              case 3:
                _context.prev = 3;
                _context.next = 6;
                return (0, _order.associationKuJiaLe)({
                  contractId: contractId
                });

              case 6:
                response = _context.sent;

                if (response && response.code === 200 && response.data && response.data.KuJiaLeFrameUrl) {
                  // 处理可能包含反引号的URL
                  kuJiaLeFrameUrl = response.data.KuJiaLeFrameUrl; // 移除可能存在的反引号

                  if (typeof kuJiaLeFrameUrl === 'string') {
                    kuJiaLeFrameUrl = kuJiaLeFrameUrl.replace(/[`]/g, '');
                  } // 获取酷家乐设计方案地址模板


                  coolHomeDesignUrlTemplate = this.$store.state.api.coolHomeDesignUrl; // 构建最终的酷家乐地址

                  coolHomeDesignUrl = coolHomeDesignUrlTemplate.replace('{kuJiaLeFrameUrl}', kuJiaLeFrameUrl).replace('{contractId}', contractId).replace('{userName}', response.data.userName); // 设置iframe的URL

                  this.coolHomeFrameUrl = coolHomeDesignUrl;
                } else {}

                _context.next = 12;
                break;

              case 10:
                _context.prev = 10;
                _context.t0 = _context["catch"](3);

              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[3, 10]]);
      }));

      function getKuJiaLeUrl() {
        return _getKuJiaLeUrl.apply(this, arguments);
      }

      return getKuJiaLeUrl;
    }(),
    handleDesign: function () {
      var _handleDesign = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(row) {
        var response, kuJiaLeFrameUrl;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (row.designScheme) {
                  _context2.next = 3;
                  break;
                }

                this.$message.error('缺少设计方案编码');
                return _context2.abrupt("return");

              case 3:
                _context2.prev = 3;
                _context2.next = 6;
                return (0, _order.getDesignSchemeUrl)({
                  designScheme: row.designScheme
                });

              case 6:
                response = _context2.sent;

                if (response && response.code === 200 && response.data && response.data.KuJiaLeFrameUrl) {
                  // 处理可能包含反引号的URL
                  kuJiaLeFrameUrl = response.data.KuJiaLeFrameUrl; // 移除可能存在的反引号

                  if (typeof kuJiaLeFrameUrl === 'string') {
                    kuJiaLeFrameUrl = kuJiaLeFrameUrl.replace(/[`]/g, '');
                  } // 在新窗口打开


                  window.open(kuJiaLeFrameUrl, '_blank');
                } else {
                  this.$message.error('获取设计方案地址失败');
                }

                _context2.next = 13;
                break;

              case 10:
                _context2.prev = 10;
                _context2.t0 = _context2["catch"](3);
                this.$message.error('调用获取设计方案地址接口失败');

              case 13:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[3, 10]]);
      }));

      function handleDesign(_x) {
        return _handleDesign.apply(this, arguments);
      }

      return handleDesign;
    }(),
    handleRowCheckChange: function handleRowCheckChange(row) {
      var _this4 = this;

      var selectedIds = this.coolHomePlanList.filter(function (item) {
        return item._checked;
      }).map(function (item) {
        return item.rowId;
      });
      this.selectedSchemeIds = selectedIds;
      this.coolHomePlanList.forEach(function (scheme) {
        var isSelected = selectedIds.includes(scheme.rowId);

        if (scheme.designSchemeAudits && scheme.designSchemeAudits.length > 0) {
          if (isSelected) {
            scheme.designSchemeAudits.forEach(function (audit) {
              audit._checked = true;
            });
            _this4.auditSelections[scheme.rowId] = scheme.designSchemeAudits.map(function (a) {
              return a.rowId;
            });
          } else {
            scheme.designSchemeAudits.forEach(function (audit) {
              audit._checked = false;
            });
            _this4.auditSelections[scheme.rowId] = [];
          }
        }
      });
      this.selectedAuditIds = Object.values(this.auditSelections).flat();
    },
    handleSelectAll: function handleSelectAll(checked) {
      this.coolHomePlanList.forEach(function (item) {
        if (item.designSchemeAudits && item.designSchemeAudits.some(function (a) {
          return a.productionStatus === '未提交' || a.productionStatus === '回退';
        })) {
          item._checked = checked;
        }
      });
      this.handleRowCheckChange({});
    },
    handleAuditSelectAll: function handleAuditSelectAll(checked, schemeRow) {
      if (schemeRow.designSchemeAudits) {
        var _editableAudits = schemeRow.designSchemeAudits.filter(function (audit) {
          return audit.productionStatus === '未提交' || audit.productionStatus === '回退';
        });

        _editableAudits.forEach(function (audit) {
          audit._checked = checked;
        });
      }

      var editableAudits = schemeRow.designSchemeAudits ? schemeRow.designSchemeAudits.filter(function (audit) {
        return audit.productionStatus === '未提交' || audit.productionStatus === '回退';
      }) : [];

      if (checked) {
        this.auditSelections[schemeRow.rowId] = editableAudits.map(function (a) {
          return a.rowId;
        });
      } else {
        this.auditSelections[schemeRow.rowId] = [];
      }

      this.selectedAuditIds = Object.values(this.auditSelections).flat();
    },
    handleSyncData: function () {
      var _handleSyncData = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(row) {
        var data, response, isSuccess, errMsg;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!(!row.id || !row.designScheme)) {
                  _context3.next = 3;
                  break;
                }

                this.$message.error('缺少设计方案ID或编码');
                return _context3.abrupt("return");

              case 3:
                if (!this.syncLoading) {
                  _context3.next = 5;
                  break;
                }

                return _context3.abrupt("return");

              case 5:
                this.syncLoading = true;
                _context3.prev = 6;
                // 构建请求参数
                data = {
                  designSchemeId: row.id,
                  designScheme: row.designScheme,
                  contractId: this.$route.query.contractId || 0
                }; // 调用接口同步数据

                _context3.next = 10;
                return (0, _order.saveKuJiaLeAuditList)(data);

              case 10:
                response = _context3.sent;
                // 统一判断响应是否成功
                isSuccess = response && (response.code === 200 || response.data && response.data.code === 200);

                if (!isSuccess) {
                  _context3.next = 23;
                  break;
                }

                this.$message.success('同步数据成功'); // 等待方案列表和提审单信息都刷新完成

                _context3.prev = 14;
                _context3.next = 17;
                return Promise.all([this.getDesignSchemes(), this.handleOperation(row)]);

              case 17:
                _context3.next = 21;
                break;

              case 19:
                _context3.prev = 19;
                _context3.t0 = _context3["catch"](14);

              case 21:
                _context3.next = 25;
                break;

              case 23:
                errMsg = response && response.msg || response && response.data && response.data.msg || '同步数据失败';
                this.$message.error(errMsg);

              case 25:
                _context3.next = 31;
                break;

              case 27:
                _context3.prev = 27;
                _context3.t1 = _context3["catch"](6);
                console.error('同步数据异常:', _context3.t1);
                this.$message.error(_context3.t1.message || '调用同步数据接口失败');

              case 31:
                _context3.prev = 31;
                this.syncLoading = false;
                return _context3.finish(31);

              case 34:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[6, 27, 31, 34], [14, 19]]);
      }));

      function handleSyncData(_x2) {
        return _handleSyncData.apply(this, arguments);
      }

      return handleSyncData;
    }(),
    handleOperation: function () {
      var _handleOperation = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(row) {
        var _this5 = this;

        var params, response;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (row.id) {
                  _context4.next = 3;
                  break;
                }

                this.$message.error('缺少设计方案ID');
                return _context4.abrupt("return");

              case 3:
                _context4.prev = 3;
                // 构建请求参数
                params = {
                  designSchemeId: row.id
                }; // 调用接口查询提审单信息

                _context4.next = 7;
                return (0, _order.getCmsCustDesignSchemeAuditList)(params);

              case 7:
                response = _context4.sent;

                if (response && (response.code === 200 || response.data)) {
                  // 处理响应数据
                  this.auditList = (response.data || []).map(function (item) {
                    // 处理特殊申请字段
                    if (item.specialApplyName) {
                      var specialApplyNames = _this5.parseSpecialApply(item.specialApplyName);

                      if (Array.isArray(specialApplyNames)) {
                        item.specialApplication = specialApplyNames.map(function (id) {
                          var apply = _this5.specialApplyOptions.find(function (opt) {
                            return opt.id === parseInt(id);
                          });

                          return apply ? apply.title : id;
                        });
                      } else {
                        item.specialApplication = [];
                      }
                    } else {
                      item.specialApplication = [];
                    } // 处理原单号字段


                    item.originalOrder = item.originalOrderNumber || '';
                    return item;
                  });
                } else {
                  this.$message.error('查询提审单信息失败');
                }

                _context4.next = 14;
                break;

              case 11:
                _context4.prev = 11;
                _context4.t0 = _context4["catch"](3);
                this.$message.error('调用查询提审单信息接口失败');

              case 14:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[3, 11]]);
      }));

      function handleOperation(_x3) {
        return _handleOperation.apply(this, arguments);
      }

      return handleOperation;
    }(),
    // 查询设计方案
    getDesignSchemes: function () {
      var _getDesignSchemes2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var _this6 = this;

        var contractId, params, response, dataList;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;
                // 从路由参数中获取contractId
                contractId = this.$route.query.contractId;
                params = {};

                if (contractId) {
                  params.contractId = contractId;
                }

                _context5.next = 6;
                return (0, _order.getDesignSchemes)(params);

              case 6:
                response = _context5.sent;

                if (response) {
                  // 处理响应数据，支持两种格式：直接数组或 { code: 200, data: [...] }
                  dataList = Array.isArray(response) ? response : response.data || []; // 转换数据格式

                  this.coolHomePlanList = dataList.map(function (item) {
                    return _objectSpread(_objectSpread({}, item), {}, {
                      id: item.rowId,
                      // 我们系统的设计方案id
                      rowId: item.rowId,
                      // 用于展开行key
                      designScheme: item.designScheme,
                      // 设计方案编码（酷家乐系统的设计方案id）
                      name: item.schemeName,
                      // 设计方案名称
                      contactPerson: item.createUserName,
                      // 关联人（创建人昵称）
                      createTime: item.createTime,
                      // 关联时间（创建时间）
                      designSchemeAudits: (item.designSchemeAudits || []).map(function (audit) {
                        var specialApplication = [];

                        if (audit.specialApplyName) {
                          var specialApplyNames = _this6.parseSpecialApply(audit.specialApplyName);

                          if (Array.isArray(specialApplyNames)) {
                            specialApplication = specialApplyNames.map(function (id) {
                              var apply = _this6.specialApplyOptions.find(function (opt) {
                                return opt.id === parseInt(id);
                              });

                              return apply ? apply.title : id;
                            });
                          }
                        }

                        return _objectSpread(_objectSpread({}, audit), {}, {
                          parentId: item.rowId,
                          _checked: false,
                          specialApplication: specialApplication,
                          originalOrder: audit.originalOrderNumber || ''
                        });
                      }),
                      // 提审单信息
                      _checked: false // 复选框选中状态

                    });
                  });
                }

                _context5.next = 14;
                break;

              case 10:
                _context5.prev = 10;
                _context5.t0 = _context5["catch"](0);
                console.error('查询设计方案失败:', _context5.t0);
                this.$message.error('查询设计方案失败');

              case 14:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this, [[0, 10]]);
      }));

      function getDesignSchemes() {
        return _getDesignSchemes2.apply(this, arguments);
      }

      return getDesignSchemes;
    }(),
    // 获取特殊申请列表
    getSpecialApplyList: function () {
      var _getSpecialApplyList = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var contractId, params, response;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.prev = 0;
                // 从路由参数中获取contractId
                contractId = this.$route.query.contractId;
                params = {};

                if (contractId) {
                  params.contractId = contractId;
                }

                _context6.next = 6;
                return (0, _contract.getContractSpecialApplyList)(params);

              case 6:
                response = _context6.sent;

                if (response && response.code === 200) {
                  // 处理响应数据
                  this.specialApplyOptions = response.data.map(function (item) {
                    return {
                      id: item.rowId,
                      title: item.title
                    };
                  });
                } else {
                  this.$message.error('获取特殊申请列表失败');
                }

                _context6.next = 14;
                break;

              case 10:
                _context6.prev = 10;
                _context6.t0 = _context6["catch"](0);
                console.error('获取特殊申请列表失败:', _context6.t0);
                this.$message.error('获取特殊申请列表失败');

              case 14:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this, [[0, 10]]);
      }));

      function getSpecialApplyList() {
        return _getSpecialApplyList.apply(this, arguments);
      }

      return getSpecialApplyList;
    }(),
    // 获取原单号列表
    getOriginalOrderList: function () {
      var _getOriginalOrderList = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        var contractNumber, currentContractNo, last4, params, response;
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.prev = 0;
                // 用原合同号（源合同号）加载原单列表，无原合同号时回退到当前合同号
                contractNumber = this.$route.query.originalContractNo || this.contractNo;

                if (contractNumber) {
                  _context7.next = 5;
                  break;
                }

                this.originalOrderOptions = [];
                return _context7.abrupt("return");

              case 5:
                // 改单/补单标记（G/B）在【当前合同号】后四位，用当前合同号判断是否需要加载原单号列表
                currentContractNo = this.contractNo || this.$route.query.contractNo || '';
                last4 = (currentContractNo || '').slice(-4);

                if (/[GgBb]/.test(last4)) {
                  _context7.next = 10;
                  break;
                }

                this.originalOrderOptions = [];
                return _context7.abrupt("return");

              case 10:
                params = {
                  contractNumber: contractNumber
                };
                _context7.next = 13;
                return (0, _order.getOriginalOrder)(params);

              case 13:
                response = _context7.sent;

                if (response && response.code === 200 && response.data) {
                  this.originalOrderOptions = (response.data || []).map(function (item) {
                    return {
                      productionOrder: item.productionOrder,
                      auditName: item.auditName
                    };
                  });
                } else if (response && Array.isArray(response.data)) {
                  this.originalOrderOptions = (response.data || []).map(function (item) {
                    return {
                      productionOrder: item.productionOrder,
                      auditName: item.auditName
                    };
                  });
                } else {
                  this.originalOrderOptions = [];
                }

                _context7.next = 21;
                break;

              case 17:
                _context7.prev = 17;
                _context7.t0 = _context7["catch"](0);
                console.error('获取原单号列表失败:', _context7.t0);
                this.originalOrderOptions = [];

              case 21:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this, [[0, 17]]);
      }));

      function getOriginalOrderList() {
        return _getOriginalOrderList.apply(this, arguments);
      }

      return getOriginalOrderList;
    }(),
    // 处理原单号选择变化
    handleOriginalOrderChange: function () {
      var _handleOriginalOrderChange = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(row) {
        var data, response;
        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.prev = 0;

                if (row.rowId) {
                  _context8.next = 3;
                  break;
                }

                return _context8.abrupt("return");

              case 3:
                data = {
                  rowId: row.rowId,
                  originalOrderNumber: row.originalOrder || ''
                };
                _context8.next = 6;
                return (0, _order.updateOriginalOrder)(data);

              case 6:
                response = _context8.sent;

                if (response && response.code === 200) {
                  this.$message.success('更新原单号成功');
                } else {
                  this.$message.error('更新原单号失败');
                }

                _context8.next = 14;
                break;

              case 10:
                _context8.prev = 10;
                _context8.t0 = _context8["catch"](0);
                console.error('更新原单号失败:', _context8.t0);
                this.$message.error('更新原单号失败');

              case 14:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this, [[0, 10]]);
      }));

      function handleOriginalOrderChange(_x4) {
        return _handleOriginalOrderChange.apply(this, arguments);
      }

      return handleOriginalOrderChange;
    }(),
    // 处理特殊申请选择变化
    handleSpecialApplyChange: function () {
      var _handleSpecialApplyChange = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee9(row) {
        var data, response;
        return regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.prev = 0;

                if (!(!row.rowId || !row.specialApplication || row.specialApplication.length === 0)) {
                  _context9.next = 3;
                  break;
                }

                return _context9.abrupt("return");

              case 3:
                // 构建请求参数
                data = {
                  title: row.specialApplication,
                  id: row.rowId
                }; // 调用接口提交关联

                _context9.next = 6;
                return (0, _order.syncApply)(data);

              case 6:
                response = _context9.sent;

                if (response && (response.code === 200 || response.data && response.data.code === 200)) {
                  this.$message.success('关联特殊申请成功');
                } else {
                  this.$message.error('关联特殊申请失败');
                }

                _context9.next = 14;
                break;

              case 10:
                _context9.prev = 10;
                _context9.t0 = _context9["catch"](0);
                console.error('关联特殊申请失败:', _context9.t0);
                this.$message.error('关联特殊申请失败');

              case 14:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this, [[0, 10]]);
      }));

      function handleSpecialApplyChange(_x5) {
        return _handleSpecialApplyChange.apply(this, arguments);
      }

      return handleSpecialApplyChange;
    }(),
    // 打开选择订单弹窗
    handleOpenSelectOrder: function handleOpenSelectOrder(row) {
      this.currentSelectOrderRow = row;
      this.showSelectOrderDialog = true;
    },
    // 选择订单弹窗打开时加载审核单列表
    handleSelectOrderDialogOpen: function () {
      var _handleSelectOrderDialogOpen = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee10() {
        var contractId, response, dataList, allAudits;
        return regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                this.selectOrderLoading = true;
                _context10.prev = 1;
                contractId = this.$route.query.contractId;

                if (contractId) {
                  _context10.next = 6;
                  break;
                }

                this.originalAuditList = [];
                return _context10.abrupt("return");

              case 6:
                _context10.next = 8;
                return (0, _order.getDesignSchemes)({
                  contractId: contractId
                });

              case 8:
                response = _context10.sent;

                if (response) {
                  dataList = Array.isArray(response) ? response : response.data || [];
                  allAudits = [];
                  dataList.forEach(function (scheme) {
                    if (scheme.designSchemeAudits && scheme.designSchemeAudits.length > 0) {
                      scheme.designSchemeAudits.forEach(function (audit) {
                        if (audit.productionOrder) {
                          allAudits.push({
                            id: audit.rowId,
                            productionOrder: audit.productionOrder,
                            auditName: audit.auditName,
                            auditStatus: audit.auditStatus,
                            productionStatus: audit.productionStatus,
                            schemeName: scheme.schemeName || scheme.name
                          });
                        }
                      });
                    }
                  });
                  this.originalAuditList = allAudits;
                }

                _context10.next = 16;
                break;

              case 12:
                _context10.prev = 12;
                _context10.t0 = _context10["catch"](1);
                console.error('获取审核单列表失败:', _context10.t0);
                this.$message.error('获取审核单列表失败');

              case 16:
                _context10.prev = 16;
                this.selectOrderLoading = false;
                return _context10.finish(16);

              case 19:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this, [[1, 12, 16, 19]]);
      }));

      function handleSelectOrderDialogOpen() {
        return _handleSelectOrderDialogOpen.apply(this, arguments);
      }

      return handleSelectOrderDialogOpen;
    }(),
    // 选择审核单行（点击后自动选中原单号并关闭弹窗）
    handleSelectAuditRow: function () {
      var _handleSelectAuditRow = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee11(row) {
        var data, response;
        return regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                if (this.currentSelectOrderRow) {
                  _context11.next = 2;
                  break;
                }

                return _context11.abrupt("return");

              case 2:
                // 将选中的订单号设为原单号
                this.currentSelectOrderRow.originalOrder = row.productionOrder;
                this.showSelectOrderDialog = false; // 更新原单号到后端

                _context11.prev = 4;
                data = {
                  rowId: this.currentSelectOrderRow.rowId,
                  originalOrderNumber: row.productionOrder
                };
                _context11.next = 8;
                return (0, _order.updateOriginalOrder)(data);

              case 8:
                response = _context11.sent;

                if (response && response.code === 200) {
                  this.$message.success('选择订单成功');
                }

                _context11.next = 15;
                break;

              case 12:
                _context11.prev = 12;
                _context11.t0 = _context11["catch"](4);
                console.error('更新原单号失败:', _context11.t0);

              case 15:
                this.currentSelectOrderRow = null;

              case 16:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this, [[4, 12]]);
      }));

      function handleSelectAuditRow(_x6) {
        return _handleSelectAuditRow.apply(this, arguments);
      }

      return handleSelectAuditRow;
    }(),
    // 打开酷家乐页面
    openCoolHomeDialog: function () {
      var _openCoolHomeDialog = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee12() {
        var contractId, response, kuJiaLeFrameUrl, coolHomeDesignUrlTemplate, coolHomeDesignUrl, errMsg, _errMsg;

        return regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                // 获取合同ID
                contractId = this.$route.query.contractId;

                if (contractId) {
                  _context12.next = 4;
                  break;
                }

                this.$message.error('缺少合同ID');
                return _context12.abrupt("return");

              case 4:
                _context12.prev = 4;
                _context12.next = 7;
                return (0, _order.associationKuJiaLe)({
                  contractId: contractId
                });

              case 7:
                response = _context12.sent;

                if (response && response.code === 200 && response.data && response.data.KuJiaLeFrameUrl) {
                  // 处理可能包含反引号的URL
                  kuJiaLeFrameUrl = response.data.KuJiaLeFrameUrl; // 移除可能存在的反引号

                  if (typeof kuJiaLeFrameUrl === 'string') {
                    kuJiaLeFrameUrl = kuJiaLeFrameUrl.replace(/[`]/g, '');
                  } // 获取酷家乐设计方案地址模板


                  coolHomeDesignUrlTemplate = this.$store.state.api.coolHomeDesignUrl; // 构建最终的酷家乐地址

                  coolHomeDesignUrl = coolHomeDesignUrlTemplate.replace('{kuJiaLeFrameUrl}', kuJiaLeFrameUrl).replace('{contractId}', contractId).replace('{userName}', response.data.userName || 'admin'); // 在新窗口打开酷家乐

                  window.open(coolHomeDesignUrl, '_blank');
                } else {
                  // 优先显示后端返回的错误信息，如 {code:500,msg:"异常：号码必须为11位数字"}
                  errMsg = response && response.msg;
                  this.$message.error(errMsg || '获取酷家乐地址失败,酷家乐账号异常，请联系管理员');
                }

                _context12.next = 15;
                break;

              case 11:
                _context12.prev = 11;
                _context12.t0 = _context12["catch"](4);
                // HTTP 层异常时，优先读取后端返回的 msg / message
                _errMsg = _context12.t0 && _context12.t0.response && _context12.t0.response.data && (_context12.t0.response.data.msg || _context12.t0.response.data.message);
                this.$message.error(_errMsg || '调用关联酷家乐方案接口失败,连接酷家乐系统异常，请联系管理员');

              case 15:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, this, [[4, 11]]);
      }));

      function openCoolHomeDialog() {
        return _openCoolHomeDialog.apply(this, arguments);
      }

      return openCoolHomeDialog;
    }(),
    // 酷家乐设计弹窗关闭时的处理
    handleCoolHomeDialogClose: function handleCoolHomeDialogClose() {
      // 重新查询方案列表
      this.getDesignSchemes();
    },
    // 处理关闭按钮点击
    handleCoolHomeClose: function handleCoolHomeClose() {
      var _this7 = this;

      // 延迟关闭弹窗，确保资源清理完成
      setTimeout(function () {
        _this7.coolHomeDialogVisible = false;
      }, 100);
    },
    // 处理提审单选择变化
    handleSelectionChange: function handleSelectionChange(val) {
      // 更新选中的提审单ID数组
      this.selectedAuditIds = val.map(function (item) {
        return item.rowId;
      });
    },
    // 处理展开行变化
    handleExpandChange: function handleExpandChange(row, expandedRows) {
      var _this8 = this;

      this.expandedRows = expandedRows;

      if (expandedRows.length === this.coolHomePlanList.length) {
        this.isAllExpanded = true;
      } else {
        this.isAllExpanded = false;
      } // 当展开方案时，自动选中该方案下之前已选中的提审单


      if (expandedRows.includes(row.rowId)) {
        this.$nextTick(function () {
          _this8.$setCheckedAudits(row);
        });
      }
    },
    // 设置展开表格中的提审单选中状态
    $setCheckedAudits: function () {
      var _$setCheckedAudits = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee13(schemeRow) {
        var _this9 = this;

        var retryCount,
            tableRef,
            selectedAuditIds,
            _args13 = arguments;
        return regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                retryCount = _args13.length > 1 && _args13[1] !== undefined ? _args13[1] : 0;

                if (!(retryCount > 10)) {
                  _context13.next = 3;
                  break;
                }

                return _context13.abrupt("return");

              case 3:
                tableRef = this.$refs['auditTable_' + schemeRow.rowId];

                if (tableRef) {
                  _context13.next = 8;
                  break;
                }

                _context13.next = 7;
                return this.$nextTick();

              case 7:
                return _context13.abrupt("return", this.$setCheckedAudits(schemeRow, retryCount + 1));

              case 8:
                selectedAuditIds = this.auditSelections[schemeRow.rowId] || [];

                if (selectedAuditIds.length > 0) {
                  schemeRow.designSchemeAudits.forEach(function (audit) {
                    if (selectedAuditIds.includes(audit.rowId) && _this9.isSelectable(audit)) {
                      tableRef.toggleRowSelection(audit, true);
                    }
                  });
                }

              case 10:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, this);
      }));

      function $setCheckedAudits(_x7) {
        return _$setCheckedAudits.apply(this, arguments);
      }

      return $setCheckedAudits;
    }(),
    // 处理行点击 - 展开/关闭
    handleRowClick: function handleRowClick(row) {
      if (this.expandedRows.includes(row.rowId)) {
        this.expandedRows = this.expandedRows.filter(function (id) {
          return id !== row.rowId;
        });
      } else {
        this.expandedRows.push(row.rowId);
      }
    },
    // 处理提审单行点击 - 展开/关闭
    handleAuditRowClick: function handleAuditRowClick(row, column) {
      if (column && column.type === 'expand') {
        return;
      }

      var tableRef = this.$refs['auditTable_' + row.parentId];

      if (tableRef) {
        tableRef.toggleRowExpansion(row);
      }
    },
    // 处理方案复选框选择变化
    handleSchemeSelectionChange: function handleSchemeSelectionChange(selection) {
      var _this10 = this;

      var selectedSchemeIds = selection.map(function (item) {
        return item.rowId;
      });
      this.selectedSchemeIds = selectedSchemeIds; // 获取当前所有方案ID

      var allSchemeIds = this.coolHomePlanList.map(function (item) {
        return item.rowId;
      }); // 清除已取消选择的方案的提审单选中状态，并更新表格复选框

      allSchemeIds.forEach(function (schemeId) {
        if (!selectedSchemeIds.includes(schemeId)) {
          delete _this10.auditSelections[schemeId]; // 更新已展开表格的复选框状态

          _this10.$nextTick(function () {
            var tableRef = _this10.$refs['auditTable_' + schemeId];

            if (tableRef) {
              var scheme = _this10.coolHomePlanList.find(function (s) {
                return s.rowId === schemeId;
              });

              if (scheme && scheme.designSchemeAudits) {
                scheme.designSchemeAudits.forEach(function (audit) {
                  tableRef.toggleRowSelection(audit, false);
                });
              }
            }
          });
        }
      }); // 当选择方案时，自动选中该方案下所有可提审的提审单

      selection.forEach(function (scheme) {
        if (scheme.designSchemeAudits && scheme.designSchemeAudits.length > 0) {
          var selectableAudits = scheme.designSchemeAudits.filter(function (audit) {
            return audit.productionStatus === '未提交' || audit.productionStatus === '退回';
          });
          _this10.auditSelections[scheme.rowId] = selectableAudits.map(function (audit) {
            return audit.rowId;
          }); // 自动展开该方案的行

          if (!_this10.expandedRows.includes(scheme.rowId)) {
            _this10.expandedRows.push(scheme.rowId);
          }
        }
      }); // 更新所有选中的提审单ID

      this.selectedAuditIds = Object.values(this.auditSelections).flat(); // 展开后设置选中状态

      this.$nextTick(function () {
        selection.forEach(function (scheme) {
          _this10.$setCheckedAudits(scheme);
        });
      });
    },
    // 处理提审单复选框选择变化
    handleAuditSelectionChange: function handleAuditSelectionChange(selection, schemeRowId) {
      this.auditSelections[schemeRowId] = selection.map(function (item) {
        return item.rowId;
      });
      this.selectedAuditIds = Object.values(this.auditSelections).flat();
    },
    // 处理提审单自定义复选框变化
    handleAuditCheckChange: function handleAuditCheckChange(checked, auditRow, schemeRow) {
      if (!this.auditSelections[schemeRow.rowId]) {
        this.auditSelections[schemeRow.rowId] = [];
      }

      if (checked) {
        if (!this.auditSelections[schemeRow.rowId].includes(auditRow.rowId)) {
          this.auditSelections[schemeRow.rowId].push(auditRow.rowId);
        }
      } else {
        var index = this.auditSelections[schemeRow.rowId].indexOf(auditRow.rowId);

        if (index > -1) {
          this.auditSelections[schemeRow.rowId].splice(index, 1);
        }
      }

      this.selectedAuditIds = Object.values(this.auditSelections).flat();
    },
    // 判断是否为成品单（成品单不允许下单/批量下单）
    isChengpinAudit: function isChengpinAudit(auditRow) {
      return !!(auditRow && (auditRow.auditName || '').trim() === '成品单');
    },
    // 从展开行创建订单
    handleCreateOrderFromExpand: function handleCreateOrderFromExpand(auditRow, schemeRow) {
      this.handleCreateOrder(auditRow);
    },
    // 处理补单（重新提交）- 与下单调用同一接口
    handleReplenishmentOrder: function () {
      var _handleReplenishmentOrder = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee15(auditRow, schemeRow) {
        var _this11 = this;

        return regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                if (auditRow.rowId) {
                  _context15.next = 3;
                  break;
                }

                this.$message.error('缺少提审单ID');
                return _context15.abrupt("return");

              case 3:
                this.$confirm('确定要重新提交吗？', '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning'
                }).then( /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee14() {
                  var data, response, isSuccess, errMsg;
                  return regeneratorRuntime.wrap(function _callee14$(_context14) {
                    while (1) {
                      switch (_context14.prev = _context14.next) {
                        case 0:
                          _this11.orderLoading = true;
                          _context14.prev = 1;
                          data = {
                            rowId: auditRow.rowId
                          };
                          _context14.next = 5;
                          return (0, _order.createMes)(data);

                        case 5:
                          response = _context14.sent;
                          isSuccess = response && (response.code === 200 || response.data && response.data.code === 200);

                          if (!isSuccess) {
                            _context14.next = 26;
                            break;
                          }

                          _this11.$message.success('补单提交成功'); // 刷新设计方案列表


                          _context14.prev = 9;
                          _context14.next = 12;
                          return _this11.getDesignSchemes();

                        case 12:
                          _context14.next = 16;
                          break;

                        case 14:
                          _context14.prev = 14;
                          _context14.t0 = _context14["catch"](9);

                        case 16:
                          _context14.prev = 16;

                          if (response.data && response.data.contractNo) {
                            _this11.contractNo = response.data.contractNo;
                          } else if (response.data && response.data.data && response.data.data.contractNo) {
                            _this11.contractNo = response.data.data.contractNo;
                          }

                          _context14.next = 20;
                          return _this11.getKuJiaLeUrl();

                        case 20:
                          _context14.next = 24;
                          break;

                        case 22:
                          _context14.prev = 22;
                          _context14.t1 = _context14["catch"](16);

                        case 24:
                          _context14.next = 28;
                          break;

                        case 26:
                          errMsg = response && response.msg || response && response.data && response.data.msg || '补单提交失败';

                          _this11.$message.error(errMsg);

                        case 28:
                          _context14.next = 34;
                          break;

                        case 30:
                          _context14.prev = 30;
                          _context14.t2 = _context14["catch"](1);
                          console.error('补单异常:', _context14.t2);

                          _this11.$message.error(_context14.t2.message || '调用补单接口失败');

                        case 34:
                          _context14.prev = 34;
                          _this11.orderLoading = false;
                          return _context14.finish(34);

                        case 37:
                        case "end":
                          return _context14.stop();
                      }
                    }
                  }, _callee14, null, [[1, 30, 34, 37], [9, 14], [16, 22]]);
                }))).catch(function () {// 取消操作
                });

              case 4:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15, this);
      }));

      function handleReplenishmentOrder(_x8, _x9) {
        return _handleReplenishmentOrder.apply(this, arguments);
      }

      return handleReplenishmentOrder;
    }(),
    // 处理创建订单
    handleCreateOrder: function () {
      var _handleCreateOrder = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee17(row) {
        var _this12 = this;

        return regeneratorRuntime.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                if (row.rowId) {
                  _context17.next = 3;
                  break;
                }

                this.$message.error('缺少提审单ID');
                return _context17.abrupt("return");

              case 3:
                // 弹出确认对话框
                this.$confirm('确定要创建订单吗？', '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning'
                }).then( /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee16() {
                  var data, response, isSuccess, errMsg;
                  return regeneratorRuntime.wrap(function _callee16$(_context16) {
                    while (1) {
                      switch (_context16.prev = _context16.next) {
                        case 0:
                          _this12.orderLoading = true;
                          _context16.prev = 1;
                          // 构建请求参数
                          data = {
                            rowId: row.rowId
                          }; // 调用接口创建订单

                          _context16.next = 5;
                          return (0, _order.createMes)(data);

                        case 5:
                          response = _context16.sent;
                          // 统一判断响应是否成功
                          isSuccess = response && (response.code === 200 || response.data && response.data.code === 200);

                          if (!isSuccess) {
                            _context16.next = 26;
                            break;
                          }

                          _this12.$message.success('创建订单成功'); // 重新查询设计方案列表，更新所有提审单信息


                          _context16.prev = 9;
                          _context16.next = 12;
                          return _this12.getDesignSchemes();

                        case 12:
                          _context16.next = 16;
                          break;

                        case 14:
                          _context16.prev = 14;
                          _context16.t0 = _context16["catch"](9);

                        case 16:
                          _context16.prev = 16;

                          // 如果接口返回了合同数据，更新合同号
                          if (response.data && response.data.contractNo) {
                            _this12.contractNo = response.data.contractNo;
                          } else if (response.data && response.data.data && response.data.data.contractNo) {
                            _this12.contractNo = response.data.data.contractNo;
                          } // 加载酷家乐


                          _context16.next = 20;
                          return _this12.getKuJiaLeUrl();

                        case 20:
                          _context16.next = 24;
                          break;

                        case 22:
                          _context16.prev = 22;
                          _context16.t1 = _context16["catch"](16);

                        case 24:
                          _context16.next = 28;
                          break;

                        case 26:
                          errMsg = response && response.msg || response && response.data && response.data.msg || '创建订单失败';

                          _this12.$message.error(errMsg);

                        case 28:
                          _context16.next = 34;
                          break;

                        case 30:
                          _context16.prev = 30;
                          _context16.t2 = _context16["catch"](1);
                          console.error('创建订单异常:', _context16.t2);

                          _this12.$message.error(_context16.t2.message || '调用创建订单接口失败');

                        case 34:
                          _context16.prev = 34;
                          _this12.orderLoading = false;
                          return _context16.finish(34);

                        case 37:
                        case "end":
                          return _context16.stop();
                      }
                    }
                  }, _callee16, null, [[1, 30, 34, 37], [9, 14], [16, 22]]);
                }))).catch(function () {// 取消操作
                });

              case 4:
              case "end":
                return _context17.stop();
            }
          }
        }, _callee17, this);
      }));

      function handleCreateOrder(_x10) {
        return _handleCreateOrder.apply(this, arguments);
      }

      return handleCreateOrder;
    }(),
    // 判断提审单是否可以选择
    isSelectable: function isSelectable(row) {
      // 未提交和退回状态可以选择
      return row.productionStatus === '未提交' || row.productionStatus === '退回';
    },
    // 删除设计方案
    handleDeleteScheme: function handleDeleteScheme(row) {
      var _this13 = this;

      this.$confirm('确定要删除该设计方案吗？删除后不可恢复。', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then( /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee18() {
        var response;
        return regeneratorRuntime.wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                _context18.prev = 0;
                _context18.next = 3;
                return (0, _order.delDesignScheme)([row.rowId]);

              case 3:
                response = _context18.sent;

                if (response && response.code === 200) {
                  _this13.$message.success('删除方案成功');

                  _this13.getDesignSchemes();
                } else {
                  _this13.$message.error(response.msg || '删除方案失败');
                }

                _context18.next = 11;
                break;

              case 7:
                _context18.prev = 7;
                _context18.t0 = _context18["catch"](0);
                console.error('删除方案失败:', _context18.t0);

                _this13.$message.error('删除方案失败，请重试');

              case 11:
              case "end":
                return _context18.stop();
            }
          }
        }, _callee18, null, [[0, 7]]);
      }))).catch(function () {});
    },
    // 取消关联设计方案
    handleUnbindScheme: function handleUnbindScheme(row) {
      var _this14 = this;

      this.$confirm('确定要取消关联该设计方案吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then( /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee19() {
        var response;
        return regeneratorRuntime.wrap(function _callee19$(_context19) {
          while (1) {
            switch (_context19.prev = _context19.next) {
              case 0:
                _context19.prev = 0;
                _context19.next = 3;
                return (0, _order.removeBindKuJiaLeCustomerDesginId)({
                  rowId: row.rowId
                });

              case 3:
                response = _context19.sent;

                if (response && response.code === 200) {
                  _this14.$message.success('取消关联成功');

                  _this14.getDesignSchemes();
                } else {
                  _this14.$message.error(response.msg || '取消关联失败');
                }

                _context19.next = 11;
                break;

              case 7:
                _context19.prev = 7;
                _context19.t0 = _context19["catch"](0);
                console.error('取消关联失败:', _context19.t0);

                _this14.$message.error('取消关联失败，请重试');

              case 11:
              case "end":
                return _context19.stop();
            }
          }
        }, _callee19, null, [[0, 7]]);
      }))).catch(function () {});
    },
    // 处理批量创建订单
    handleBatchCreateOrder: function () {
      var _handleBatchCreateOrder = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee21() {
        var _this15 = this;

        return regeneratorRuntime.wrap(function _callee21$(_context21) {
          while (1) {
            switch (_context21.prev = _context21.next) {
              case 0:
                if (!(this.selectedAuditIds.length === 0)) {
                  _context21.next = 3;
                  break;
                }

                this.$message.error('请至少选择一个提审单');
                return _context21.abrupt("return");

              case 3:
                // 弹出确认对话框
                this.$confirm("\u786E\u5B9A\u8981\u4E3A\u9009\u4E2D\u7684".concat(this.selectedAuditIds.length, "\u4E2A\u63D0\u5BA1\u5355\u521B\u5EFA\u8BA2\u5355\u5417\uFF1F"), '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning'
                }).then( /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee20() {
                  var response, isSuccess, errMsg;
                  return regeneratorRuntime.wrap(function _callee20$(_context20) {
                    while (1) {
                      switch (_context20.prev = _context20.next) {
                        case 0:
                          _this15.orderLoading = true;
                          _context20.prev = 1;
                          _context20.next = 4;
                          return (0, _order.batchCreateMes)(_this15.selectedAuditIds);

                        case 4:
                          response = _context20.sent;
                          // 统一判断响应是否成功
                          isSuccess = response && (response.code === 200 || response.data && response.data.code === 200);

                          if (!isSuccess) {
                            _context20.next = 21;
                            break;
                          }

                          _this15.$message.success('批量创建订单成功'); // 重新查询设计方案列表，更新所有提审单信息


                          _context20.prev = 8;
                          _context20.next = 11;
                          return _this15.getDesignSchemes();

                        case 11:
                          // 清空选中的提审单ID数组
                          _this15.selectedAuditIds = []; // 清空提审单选中状态

                          _this15.auditSelections = {};
                          _context20.next = 19;
                          break;

                        case 15:
                          _context20.prev = 15;
                          _context20.t0 = _context20["catch"](8);
                          // 子接口失败时，只提示，选中状态仍然清除
                          _this15.selectedAuditIds = [];
                          _this15.auditSelections = {};

                        case 19:
                          _context20.next = 23;
                          break;

                        case 21:
                          errMsg = response && response.msg || response && response.data && response.data.msg || '批量创建订单失败';

                          _this15.$message.error(errMsg);

                        case 23:
                          _context20.next = 29;
                          break;

                        case 25:
                          _context20.prev = 25;
                          _context20.t1 = _context20["catch"](1);
                          console.error('批量创建订单异常:', _context20.t1);

                          _this15.$message.error(_context20.t1.message || '调用批量创建订单接口失败');

                        case 29:
                          _context20.prev = 29;
                          _this15.orderLoading = false;
                          return _context20.finish(29);

                        case 32:
                        case "end":
                          return _context20.stop();
                      }
                    }
                  }, _callee20, null, [[1, 25, 29, 32], [8, 15]]);
                }))).catch(function () {// 取消操作
                });

              case 4:
              case "end":
                return _context21.stop();
            }
          }
        }, _callee21, this);
      }));

      function handleBatchCreateOrder() {
        return _handleBatchCreateOrder.apply(this, arguments);
      }

      return handleBatchCreateOrder;
    }(),
    handleBatchTryInstall: function () {
      var _handleBatchTryInstall = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee23(isTryInstall) {
        var _this16 = this;

        var canUpdate, actionText;
        return regeneratorRuntime.wrap(function _callee23$(_context23) {
          while (1) {
            switch (_context23.prev = _context23.next) {
              case 0:
                canUpdate = isTryInstall ? this.canBatchSetTryInstall : this.canBatchCancelTryInstall;

                if (canUpdate) {
                  _context23.next = 4;
                  break;
                }

                this.$message.warning(isTryInstall ? '仅未提交且当前为正常订单的销售单可以试装' : '仅未提交且当前为试装的销售单可以取消试装');
                return _context23.abrupt("return");

              case 4:
                actionText = isTryInstall ? '设置为试装' : '取消试装';
                this.$confirm("\u786E\u5B9A\u5C06\u9009\u4E2D\u7684".concat(this.selectedAuditIds.length, "\u4E2A\u8BA2\u5355").concat(actionText, "\u5417\uFF1F"), '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning'
                }).then( /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee22() {
                  var response, isSuccess, errMsg;
                  return regeneratorRuntime.wrap(function _callee22$(_context22) {
                    while (1) {
                      switch (_context22.prev = _context22.next) {
                        case 0:
                          _this16.orderLoading = true;
                          _context22.prev = 1;
                          _context22.next = 4;
                          return (0, _order.batchUpdateTryInstall)({
                            ids: _this16.selectedAuditIds,
                            isTryInstall: isTryInstall
                          });

                        case 4:
                          response = _context22.sent;
                          isSuccess = response && (response.code === 200 || response.data && response.data.code === 200);

                          if (!isSuccess) {
                            _context22.next = 14;
                            break;
                          }

                          _this16.$message.success("\u6279\u91CF".concat(actionText, "\u6210\u529F"));

                          _context22.next = 10;
                          return _this16.getDesignSchemes();

                        case 10:
                          _this16.selectedAuditIds = [];
                          _this16.auditSelections = {};
                          _context22.next = 16;
                          break;

                        case 14:
                          errMsg = response && response.msg || response && response.data && response.data.msg || "\u6279\u91CF".concat(actionText, "\u5931\u8D25");

                          _this16.$message.error(errMsg);

                        case 16:
                          _context22.next = 22;
                          break;

                        case 18:
                          _context22.prev = 18;
                          _context22.t0 = _context22["catch"](1);
                          console.error("\u6279\u91CF".concat(actionText, "\u5F02\u5E38:"), _context22.t0);

                          _this16.$message.error(_context22.t0.message || "\u8C03\u7528\u6279\u91CF".concat(actionText, "\u63A5\u53E3\u5931\u8D25"));

                        case 22:
                          _context22.prev = 22;
                          _this16.orderLoading = false;
                          return _context22.finish(22);

                        case 25:
                        case "end":
                          return _context22.stop();
                      }
                    }
                  }, _callee22, null, [[1, 18, 22, 25]]);
                }))).catch(function () {// 取消操作
                });

              case 6:
              case "end":
                return _context23.stop();
            }
          }
        }, _callee23, this);
      }));

      function handleBatchTryInstall(_x11) {
        return _handleBatchTryInstall.apply(this, arguments);
      }

      return handleBatchTryInstall;
    }(),
    // 订单层级-更新（同步生产数量）
    handleSyncProductionNum: function () {
      var _handleSyncProductionNum = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee25(row) {
        var _this17 = this;

        return regeneratorRuntime.wrap(function _callee25$(_context25) {
          while (1) {
            switch (_context25.prev = _context25.next) {
              case 0:
                if (!(!row || !row.rowId)) {
                  _context25.next = 3;
                  break;
                }

                this.$message.error('缺少提审单ID');
                return _context25.abrupt("return");

              case 3:
                this.$confirm('确定要更新该订单的生产数量吗？', '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning'
                }).then( /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee24() {
                  var response, isSuccess, errMsg;
                  return regeneratorRuntime.wrap(function _callee24$(_context24) {
                    while (1) {
                      switch (_context24.prev = _context24.next) {
                        case 0:
                          _context24.prev = 0;
                          _context24.next = 3;
                          return (0, _contract.syncProductionNum)({
                            auditId: row.rowId
                          });

                        case 3:
                          response = _context24.sent;
                          isSuccess = response && (response.code === 200 || response.data && response.data.code === 200);

                          if (!isSuccess) {
                            _context24.next = 16;
                            break;
                          }

                          _this17.$message.success('更新成功'); // 刷新设计方案列表


                          _context24.prev = 7;
                          _context24.next = 10;
                          return _this17.getDesignSchemes();

                        case 10:
                          _context24.next = 14;
                          break;

                        case 12:
                          _context24.prev = 12;
                          _context24.t0 = _context24["catch"](7);

                        case 14:
                          _context24.next = 18;
                          break;

                        case 16:
                          errMsg = response && response.msg || response && response.data && response.data.msg || '更新失败';

                          _this17.$message.error(errMsg);

                        case 18:
                          _context24.next = 24;
                          break;

                        case 20:
                          _context24.prev = 20;
                          _context24.t1 = _context24["catch"](0);
                          console.error('更新生产数量异常:', _context24.t1);

                          _this17.$message.error(_context24.t1.message || '调用更新接口失败');

                        case 24:
                        case "end":
                          return _context24.stop();
                      }
                    }
                  }, _callee24, null, [[0, 20], [7, 12]]);
                }))).catch(function () {// 取消操作
                });

              case 4:
              case "end":
                return _context25.stop();
            }
          }
        }, _callee25, this);
      }));

      function handleSyncProductionNum(_x12) {
        return _handleSyncProductionNum.apply(this, arguments);
      }

      return handleSyncProductionNum;
    }(),
    // ============ 大家居订单-成品物料弹窗 ============
    // 打开弹窗
    openDajiajuOrderDialog: function openDajiajuOrderDialog() {
      this.showDajiajuOrderDialog = true;
    },
    // 弹窗打开时加载数据
    loadDajiajuMaterialTable: function loadDajiajuMaterialTable() {
      var _this18 = this;

      this.handleDajiajuMaterialSearch();
      this.$nextTick(function () {
        if (_this18.$refs.dajiajuMaterialTable) {
          _this18.$refs.dajiajuMaterialTable.clearSelection();
        }
      });
    },
    // 弹窗关闭时清空选中
    handleDajiajuDialogClose: function handleDajiajuDialogClose() {
      var _this19 = this;

      this.tempSelectedDajiajuMaterials = [];
      this.$nextTick(function () {
        if (_this19.$refs.dajiajuMaterialTable) {
          _this19.$refs.dajiajuMaterialTable.clearSelection();
        }
      });
    },
    // 输入即搜索（带防抖）
    debouncedDajiajuSearch: function debouncedDajiajuSearch() {
      var _this20 = this;

      if (this.dajiajuSearchTimer) clearTimeout(this.dajiajuSearchTimer);
      this.dajiajuSearchTimer = setTimeout(function () {
        _this20.handleDajiajuMaterialSearch();
      }, 400);
    },
    // 搜索
    handleDajiajuMaterialSearch: function handleDajiajuMaterialSearch() {
      this.dajiajuMaterialLoading = true;
      this.dajiajuMaterialPage = 1;
      this.queryDajiajuMaterialTable();
    },
    // 重置搜索条件
    handleDajiajuMaterialSearchReset: function handleDajiajuMaterialSearchReset() {
      this.dajiajuMaterialSearch = {
        code: '',
        name: ''
      };
      this.handleDajiajuMaterialSearch();
    },
    // 查询成品物料列表
    queryDajiajuMaterialTable: function queryDajiajuMaterialTable() {
      var _this21 = this;

      var params = {
        page: this.dajiajuMaterialPage,
        limit: this.dajiajuMaterialPageSize,
        code: this.dajiajuMaterialSearch.code || '',
        name: this.dajiajuMaterialSearch.name || ''
      };
      (0, _cmsCustBom.getMaterialChengPin)(params).then(function (response) {
        if (response.code === 200) {
          var data = response.data || {};
          var list = data.content || data.records || data.list || [];
          _this21.dajiajuMaterialList = list;
          _this21.dajiajuMaterialTotal = data.totalElements || data.total || data.count || list.length || 0;
        } else {
          _this21.dajiajuMaterialList = [];
          _this21.dajiajuMaterialTotal = 0;
        }
      }).catch(function () {
        _this21.dajiajuMaterialList = [];
        _this21.dajiajuMaterialTotal = 0;
      }).finally(function () {
        _this21.dajiajuMaterialLoading = false;
      });
    },
    // 分页切换
    handleDajiajuMaterialPageChange: function handleDajiajuMaterialPageChange(page) {
      this.dajiajuMaterialPage = page;
      this.queryDajiajuMaterialTable();
    },
    // 选中变化（增量合并，保留其它页选中项）
    handleDajiajuMaterialSelectionChange: function handleDajiajuMaterialSelectionChange(rows) {
      var _this22 = this;

      var currentPageKeys = new Set(this.dajiajuMaterialList.map(function (r) {
        return r.id || r.code;
      }));
      var checkedKeys = new Set(rows.map(function (r) {
        return r.id || r.code;
      })); // 移除当前页中取消勾选的项

      this.tempSelectedDajiajuMaterials = this.tempSelectedDajiajuMaterials.filter(function (item) {
        var key = item.id || item.code;

        if (currentPageKeys.has(key) && !checkedKeys.has(key)) {
          return false;
        }

        return true;
      }); // 添加当前页中新勾选的项

      rows.forEach(function (row) {
        var key = row.id || row.code;

        if (!_this22.tempSelectedDajiajuMaterials.some(function (s) {
          return (s.id || s.code) === key;
        })) {
          // 复制一份并默认数量为 1，避免直接引用列表行对象
          _this22.tempSelectedDajiajuMaterials.push(_objectSpread(_objectSpread({}, row), {}, {
            quantity: row.quantity || 1
          }));
        }
      });
    },
    // 从已选列表删除单个物料
    removeDajiajuMaterial: function removeDajiajuMaterial(row) {
      var _this23 = this;

      var key = row.id || row.code;
      this.tempSelectedDajiajuMaterials = this.tempSelectedDajiajuMaterials.filter(function (s) {
        return (s.id || s.code) !== key;
      }); // 若该行在当前页，同步取消表格勾选

      this.$nextTick(function () {
        var table = _this23.$refs.dajiajuMaterialTable;
        if (!table) return;

        var currentRow = _this23.dajiajuMaterialList.find(function (r) {
          return (r.id || r.code) === key;
        });

        if (currentRow) {
          table.toggleRowSelection(currentRow, false);
        }
      });
    },
    // 清空已选物料
    clearDajiajuMaterials: function clearDajiajuMaterials() {
      var _this24 = this;

      this.tempSelectedDajiajuMaterials = [];
      this.$nextTick(function () {
        if (_this24.$refs.dajiajuMaterialTable) {
          _this24.$refs.dajiajuMaterialTable.clearSelection();
        }
      });
    },
    // 确定选择并提交大家居订单
    confirmDajiajuMaterialSelect: function confirmDajiajuMaterialSelect() {
      var _this25 = this;

      if (this.tempSelectedDajiajuMaterials.length === 0) {
        this.$message.warning('请先选择物料');
        return;
      }

      var addContractId = this.$route.query.contractId;

      if (!addContractId) {
        this.$message.error('缺少合同ID，无法提交大家居订单');
        return;
      }

      this.$confirm("\u786E\u5B9A\u4E3A\u5F53\u524D\u5408\u540C\u63D0\u4EA4 ".concat(this.tempSelectedDajiajuMaterials.length, " \u4E2A\u5927\u5BB6\u5C45\u6210\u54C1\u7269\u6599\u5417\uFF1F"), '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then( /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee26() {
        var response, isSuccess, errMsg;
        return regeneratorRuntime.wrap(function _callee26$(_context26) {
          while (1) {
            switch (_context26.prev = _context26.next) {
              case 0:
                _this25.dajiajuSubmitting = true;
                _context26.prev = 1;
                _context26.next = 4;
                return (0, _cmsCustBom.addChengPin)({
                  addContractId: addContractId,
                  list: _this25.tempSelectedDajiajuMaterials.map(function (item) {
                    return _objectSpread({}, item);
                  })
                });

              case 4:
                response = _context26.sent;
                isSuccess = response && (response.code === 200 || response.data && response.data.code === 200);

                if (!isSuccess) {
                  _context26.next = 20;
                  break;
                }

                _this25.$message.success('大家居订单提交成功');

                _this25.showDajiajuOrderDialog = false; // 清空选中状态

                _this25.tempSelectedDajiajuMaterials = [];

                _this25.$nextTick(function () {
                  if (_this25.$refs.dajiajuMaterialTable) {
                    _this25.$refs.dajiajuMaterialTable.clearSelection();
                  }
                }); // 刷新设计方案列表


                _context26.prev = 11;
                _context26.next = 14;
                return _this25.getDesignSchemes();

              case 14:
                _context26.next = 18;
                break;

              case 16:
                _context26.prev = 16;
                _context26.t0 = _context26["catch"](11);

              case 18:
                _context26.next = 22;
                break;

              case 20:
                errMsg = response && response.msg || response && response.data && response.data.msg || '大家居订单提交失败';

                _this25.$message.error(errMsg);

              case 22:
                _context26.next = 28;
                break;

              case 24:
                _context26.prev = 24;
                _context26.t1 = _context26["catch"](1);
                console.error('大家居订单提交异常:', _context26.t1);

                _this25.$message.error(_context26.t1.message || '调用大家居订单提交接口失败');

              case 28:
                _context26.prev = 28;
                _this25.dajiajuSubmitting = false;
                return _context26.finish(28);

              case 31:
              case "end":
                return _context26.stop();
            }
          }
        }, _callee26, null, [[1, 24, 28, 31], [11, 16]]);
      }))).catch(function () {// 取消操作
      });
    }
  }
};
exports.default = _default;